var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-3 mx-n3",
    attrs: {
      "max-width": "480",
      "width": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "해시태그 설정"
    }
  }), _c('v-card', _vm._b({
    attrs: {
      "outlined": ""
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-text', [_vm.setting ? [_c('v-text-field', _vm._b({
    attrs: {
      "label": "신규항목",
      "placeholder": "키워드 작성 후 Enter를 눌러주세요",
      "append-icon": "mdi-plus"
    },
    on: {
      "click:append": _vm.add,
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.add($event);
      }
    },
    model: {
      value: _vm.text,
      callback: function callback($$v) {
        _vm.text = $$v;
      },
      expression: "text"
    }
  }, 'v-text-field', _vm.attrs_input, false)), _c('v-chip-group', {
    attrs: {
      "column": ""
    }
  }, [_c('draggable', {
    staticClass: "mb-n2",
    model: {
      value: _vm.setting.hashTags,
      callback: function callback($$v) {
        _vm.$set(_vm.setting, "hashTags", $$v);
      },
      expression: "setting.hashTags"
    }
  }, [_vm._l(_vm.setting.hashTags, function (item, index) {
    return [_c('v-chip', {
      key: item,
      attrs: {
        "outlined": "",
        "label": "",
        "close": ""
      },
      on: {
        "click:close": function clickClose($event) {
          return _vm.setting.hashTags.splice(index, 1);
        }
      }
    }, [_vm._v(" " + _vm._s(item) + " ")])];
  })], 2)], 1)] : [_c('v-skeleton-loader', {
    attrs: {
      "type": "image"
    }
  })]], 2), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', _vm._b({
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("저장")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }